
import { Injectable, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs/Rx';

/**
 * A simple service representing the application's loading status.
 * Whenever other services or components start an asynchronous long time operation,
 * they may register new load and unregister it again whenever that operation completes.
 *
 * Components like loading-spinner will automatically be visible depending on the state
 * of this service.
 */
@Injectable()
export class LoadingStateService {
    /** yields true, if currently loading. false when loading has completed. */
    public loadStateChanged = new EventEmitter<boolean>();
    public isLoading: boolean;
    /** Zero means: load is completed. */
    private currentLoad: number = 0;

    constructor() { }

    public addLoad(amount: number = 1) {
        if (amount < 1)
            throw new Error("amount should be 1 or greater.");

        this.currentLoad += amount;
        this.invalidateState();
    }

    public removeLoad(amount: number = 1) {
        if (amount < 1)
            throw new Error("amount should be 1 or greater.");

        this.currentLoad = Math.max(0, this.currentLoad - amount);
        this.invalidateState();
    }

    public removeAllLoad() {
        this.currentLoad = 0;
        this.invalidateState();
    }

    private invalidateState() {
        const wasLoading = this.isLoading;
        this.isLoading = this.currentLoad !== 0;

        if (this.isLoading === wasLoading)
            return;

        this.loadStateChanged.emit(this.isLoading);
    }
}



// WEBPACK FOOTER //
// ./src/viega-common/services/loading-state-service.ts